// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__1t-Lk","infoLink":"tweet-info_infoLink__2yGko","infoIcon":"tweet-info_infoIcon__8Qny5"};